export const overviewData = ({ lessonOverviewReducer: { data } }) => data;
